import React from 'react';
import { Typography } from '@mui/material';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';

const DataGridClientContactName = ({ clientId, clientContact }) => {
	const { data: clientRow } = useGetClientRowQuery(clientId, {
		skip: !clientId,
	});

	const contactName = clientContact ?? clientRow?.contactName;

	return <Typography>{contactName || '-'}</Typography>;
};

export default DataGridClientContactName;
